module.exports = __webpack_public_path__ + "img/bingo_ball-62.572cfa9f.png";